import React from "react";
import { LegalLayout, Section } from "@/components/LegalLayout";

export default function Imprint() {
  return (
    <LegalLayout title="Impressum" testid="imprint-page">
      <Section title="Angaben gemäß § 5 ECG / § 5 TMG / § 25 MedienG">
        <p>
          Mathias Walch<br />
          Neufeldstraße 13<br />
          6890 Lustenau<br />
          Österreich
        </p>
      </Section>

      <Section title="Kontakt">
        <p>
          E-Mail: office@mw3d.at<br />
          Web: safe-buddy.com
        </p>
      </Section>

      <Section title="Unternehmensangaben">
        <p>
          Unternehmensgegenstand: Handel mit NFC-Notfallprodukten und Betrieb der SafeBuddy Web-App<br />
          Gemäß § 6 Abs. 1 Z 27 UStG wird keine Umsatzsteuer berechnet (Kleinunternehmerregelung).
        </p>
      </Section>

      <Section title="Verantwortlich für den Inhalt">
        <p>Mathias Walch, Anschrift wie oben.</p>
      </Section>

      <Section title="Online-Streitbeilegung">
        <p>Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="underline">https://ec.europa.eu/consumers/odr</a>. Wir sind nicht verpflichtet und grundsätzlich nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
      </Section>


    </LegalLayout>
  );
}
